import { useCallback } from 'react';

import { clearPrivySessionBestEffort } from './privy-session';
import { usePrivySession } from './use-privy-session';
import { walletUnlockSession } from './wallet-unlock-session';

export function useEndPrivySession(): () => Promise<void> {
  const session = usePrivySession();

  return useCallback(() => clearPrivySessionBestEffort(session), [session]);
}

export function useWalletLock(endPrivySession: () => Promise<void>): () => Promise<void> {
  return useCallback(async () => {
    walletUnlockSession.lock();
    await endPrivySession();
  }, [endPrivySession]);
}
